import { Card, Form, Input, Row, Col, Button } from "antd";
import { StyledSelect } from "../../planejamentoOperacional/components/ModalOrdemServicoMatriz/components/ModalCadastroOrdemServico/styles";

const { Item, useForm } = Form;

interface FiltersGestaoJobsProps {
  data?: any[];
  handleFilter: (values: any) => void;
}

function FiltersGestaoJobs({ data, handleFilter }: FiltersGestaoJobsProps) {
  const [form] = useForm();

  const statusOptions = [
    { value: "", label: "Todos" },
    { value: true, label: "Ativo" },
    { value: false, label: "Inativo" },
  ];

  return (
    <Card style={{ margin: 16, borderRadius: 8 }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFilter}
        initialValues={{ ativo: "" }}
      >
        <Row gutter={[8, 8]}>
          <Col span={12}>
            <Item label="Descrição" name="name" style={{ margin: 0 }}>
              <Input
                size="large"
                style={{ borderRadius: 8 }}
                placeholder="Buscar por descrição..."
              />
            </Item>
          </Col>
          <Col span={10}>
            <Item label="Status" name="ativo" style={{ margin: 0 }}>
              <StyledSelect allowClear size="large" options={statusOptions} />
            </Item>
          </Col>
          <Col span={2} style={{ display: "flex", alignItems: "flex-end" }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{
                width: "100%",
                borderRadius: 8,
                backgroundColor: "#12619C",
              }}
            >
              Filtrar
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default FiltersGestaoJobs;
